// export function clearObject(object: any): any {
//   if(!object) {
//     return;
//   }
//   return Object.fromEntries(Object.entries(object).filter(([_, v]: any) => v?.length))
// }

// export function cleanObject<T extends Record<string, any>>(obj: T): T {
//   return Object.keys(obj)
//     .filter((key) => obj[key as keyof T] !== null)
//     .reduce((acc, key) => {
//       acc[key as keyof T] = obj[key as keyof T];
//       return acc;
//     }, {} as T);
// }

export function cleanObject<T extends Record<string, any>>(obj: T): T {
  return Object.keys(obj)
    .reduce((acc, key) => {
      const value = obj[key];

      // Remove null or undefined values
      if (value === null || value === undefined) {
        return acc;
      }

      // If it's an array, remove empty arrays but keep non-empty arrays
      if (Array.isArray(value)) {
        if (value.length > 0) {
          // @ts-ignore
          acc[key] = value;  // Retain non-empty arrays
        }
      } else {
        // Convert non-array values to arrays
        // @ts-ignore
        acc[key] = [value];
      }

      return acc;
    }, {} as T);
}
